module.exports = "/img/_/_/_/assets/images/creeper/battle/rare//empty.jpg?1bca96feb2c2c20538261bb2f10e3f04";